import { ResponseError } from '../../errors';
import { fetchMessagesUnread, TMessagesUnreadResponse } from '../../repositories/chats/v1/messages/unread';
import { IApplicationContext } from '../../types/applicationContext';

export async function getUnreadMessages(context: IApplicationContext, isAuthenticated: boolean): Promise<number> {
  if (!isAuthenticated) {
    return 0;
  }

  const { httpApi, logger } = context;

  try {
    const messages: TMessagesUnreadResponse = await fetchMessagesUnread({
      httpApi,
    });

    if (messages.statusCode !== 200) {
      throw new ResponseError({
        domain: 'getUnreadMessages',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        message: messages.response.message!,
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: messages.response.errors as any,
        },
      });
    }

    return messages.response.unread || 0;
  } catch (ex) {
    logger.warning(ex, {
      domain: 'getUnreadMessages',
      message: 'Failed to get unread messages',
    });

    return 0;
  }
}
